'use client';
// eslint-disable-next-line import/export
export * from 'swr';
// eslint-disable-next-line import/export
export { default as useSWR, SWRConfig } from 'swr';
export { default as useSWRInfinite } from 'swr/infinite';
